<div class="container d-flex justify-content-between">
  <div
    [matTooltip]="agentInfo().lastLog ? ('app.device.agent.last_update' | translate) + ' : ' + agentInfo().lastLog : ''"
    class="agent d-flex items-center gap-md ms-4">
    <div class="agent-activity-state {{ agentInfo().state }}"></div>
    <div class="agent-message">{{ agentInfo().messageKey | translate }}</div>
  </div>

  <div class="device-actions d-flex justify-content-end items-center gap-md">
    @for (item of visibleActions(); track item.permission) {
    <button mat-button class="action-btn" (click)="item.action()">
      <mat-icon [class]="item.class">{{ item.icon }}</mat-icon>
      <span>{{ item.label | translate }}</span>
    </button>
    }
  </div>
</div>